export default __webpack_public_path__ + "static/media/paella.2a9f51d0.png";